import type { TodoItem } from './sessionModel'

/**
 * A Task-tool `in_progress` value describes work inside the current turn, not
 * an independent background process. Settle it when that turn terminates so
 * the Tasks panel cannot keep spinning while the session is idle. Pending and
 * completed rows are left untouched; a later SDK TaskUpdate/TaskList remains
 * authoritative and can move a paused/failed row back into progress.
 */
export function settleInProgressTodos(
  todos: TodoItem[],
  terminalStatus: 'paused' | 'failed',
): TodoItem[] {
  if (!todos.some((todo) => todo.status === 'in_progress')) return todos
  return todos.map((todo) => todo.status === 'in_progress'
    ? { ...todo, status: terminalStatus }
    : todo)
}
